var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mult-offer"},_vm._l((_vm.offerList),function(item,index){return _c('MultOfferItem',{key:index,attrs:{"offer":item,"likeClass":_vm.likeClass,"iconName":_vm.iconName,"text":_vm.text},on:{"buyOffer":_vm.buyOffer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }